import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useMemo } from 'react';
import Icon from '../Icon';
import clss from 'classnames';
import Loading from 'react-loading';
var Input = function(props) {
    var onEnter = props.onEnter, className = props.className, _mode = props.mode, mode = _mode === void 0 ? 'normal' : _mode, icon = props.icon, placeholder = props.placeholder, loading = props.loading, onChange = props.onChange;
    var iconType = useMemo(function() {
        if (icon) return icon;
        if (mode === 'search') return 'search'; // todo
    }, [
        icon,
        mode
    ]);
    var onkeyup = useCallback(function(event) {
        if (event.which === 13 && mode === 'search') {
            var value = event.target.value;
            onEnter && onEnter(value);
        }
    }, [
        onEnter,
        mode
    ]);
    return(/*#__PURE__*/ _jsxs("div", {
        className: "relative",
        children: [
            iconType && /*#__PURE__*/ _jsx(Icon, {
                type: iconType,
                className: "absolute left-[18px] top-[9px] text-[24px] text-[#cccccc]"
            }),
            /*#__PURE__*/ _jsx("input", {
                type: "text",
                placeholder: placeholder,
                className: clss('h-[36px] py-[2px] w-[590px] border-base border-[1px] rounded-[4px] bg-transparent outline-none text-desc placeholder:text-[#cccccc]', className, iconType ? 'pl-[52px]' : 'pl-[15px]'),
                onKeyUp: onkeyup,
                onChange: onChange
            }),
            loading && /*#__PURE__*/ _jsx("div", {
                className: "absolute right-[-28px] top-[11px]",
                children: /*#__PURE__*/ _jsx(Loading, {
                    type: "spin",
                    height: 20,
                    width: 20,
                    color: "#222"
                })
            })
        ]
    }));
};
export default Input;
